import React, { createContext, useEffect, useState, useContext, useRef } from 'react';
import { toast } from "react-toastify";

const ConnectionContext = createContext();

export const ConnectionProvider = ({ children }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isSlow, setIsSlow] = useState(false);

  const prevIsOnline = useRef(isOnline);
  const prevIsSlow = useRef(isSlow);

  useEffect(() => {
    const updateOnlineStatus = () => setIsOnline(navigator.onLine);

    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    const updateConnectionQuality = () => {
      if (connection) {
        if (connection.downlink < 1) {
          setIsSlow(true);
        } else {
          setIsSlow(false);
        }
      }
    };
    if (connection) {
      connection.addEventListener('change', updateConnectionQuality);
      updateConnectionQuality();
    }

    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
      if (connection) {
        connection.removeEventListener('change', updateConnectionQuality);
      }
    };
  }, []);

  useEffect(() => {
    if (!isOnline) {
      toast.error("No internet connection", { toastId: "offlineToast" });
    } else {
      if (prevIsOnline.current === false) {
        toast.success("Internet connection restored", { toastId: "restoredToast" });
      }
      if (isSlow) {
        toast.warn("Your internet connection is really slow", { toastId: "slowToast" });
      } else {
        toast.dismiss("slowToast");
      }
      toast.dismiss("offlineToast");
    }
    prevIsOnline.current = isOnline;
    prevIsSlow.current = isSlow;
  }, [isOnline, isSlow]);

  return (
    <ConnectionContext.Provider value={{ isOnline, isSlow }}>
      {children}
    </ConnectionContext.Provider>
  );
};

export const useConnection = () => useContext(ConnectionContext);
